export default __webpack_public_path__ + "static/media/house.117f6fd7.svg";